import { render, staticRenderFns } from "./TransfersNumber.vue?vue&type=template&id=43b6a31c&scoped=true&"
import script from "./TransfersNumber.vue?vue&type=script&lang=js&"
export * from "./TransfersNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b6a31c",
  null
  
)

export default component.exports